import React from 'react';

const Footer = () => (
  <footer>
    <span>BOLDIT Ltd &bull; Koče Racina 7 &bull; 40000 Čakovec &bull; Croatia</span>&nbsp;|&nbsp;
    <span>Tel: +385 99 699 0856</span>&nbsp;|&nbsp;
    <span>E-mail: info@boldit.hr</span>&nbsp;|&nbsp;
    <span>© {new Date().getFullYear()} BOLDIT Ltd</span>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js